import { ConfirmPopup, ConfirmPopupProps } from 'primereact/confirmpopup';

type _CustomConfirmPopupProps = ConfirmPopupProps & {
    children?: React.ReactNode;
};

const MlxConfirmPopup = (props: Readonly<_CustomConfirmPopupProps>) => {
    let { className, onHide, children, style, ...rest } = props;

    if (!className) {
        className = 'mlx-confirm-popup';
    }

    return (
        <ConfirmPopup className={className} {...rest}>
            {children}
        </ConfirmPopup>
    );
};

export default MlxConfirmPopup;
